import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'search.floater.title',
    defaultMessage: 'Besoin d’aide ? Nous sommes là pour vous accompagner !',
  },
  subtitle: {
    id: 'search.page.subtitle',
    defaultMessage: `Contactez notre équipe pédagogique, nous vous aiderons à trouver le Sherpa qu’il vous faut.`,
  },
  button: {
    id: 'search.floater.button',
    defaultMessage: 'Trouvez-moi un Sherpa',
  },
});
